export default __webpack_public_path__ + "static/media/blossom-icon.b2951183.png";